/** Main stores match_date as an event-local SQL date. Keep that date intact; do not parse it as UTC. */
export function matchCalendarDate(match: { match_date: string }): string {
  return match.match_date.slice(0, 10);
}
